<template>
<div id="app">
  <!-- <left-panel v-if="connected" :context="context"></left-panel>
  <right-panel v-if="connected"></right-panel> -->
  <f7-views>
    <f7-view :domCache="false" :uniqueHistory="false" id="main-view" :key="connected" main :url="url">
    <!-- <f7-view :domCache="false" :uniqueHistory="false" id="main-view" main url="history"> -->
      <!-- <web-header v-if="connected && !isSmartphoneOS"
        :key="'web-header-' + webheaderKey"
        :context="context">
      </web-header>
      <mobile-header v-if="connected"
        :context="context">
      </mobile-header> -->
      <left-panel :stats="stats" :isSidebarOpen="isSidebarOpen" @update:isSidebarOpen="isSidebarOpen = $event"></left-panel>
      <header-panel :isSidebarOpen="isSidebarOpen"></header-panel>
      <div v-if="!minimize" :class="['card-auto', {yellow: isPaused && !isLoading, blue: isLoading && !isPaused, green: !isPaused && !isLoading}]">
        <div style="display: flex; align-items: center; justify-content: space-between;" class="px-6 py-4">
          <div style="display: flex; align-items: center; gap: 0.5rem;">
            <span>🤖</span>
            <div :style="{'border-radius': '50%', 'background-color': isPaused? '#f0b100': !isLoading ? '#00c951':'oklch(62.3% 0.214 259.815)', height: '0.6rem', width: '0.6rem'}"></div>
            <span>Auto-match: {{ isPaused ? 'Paused' : !isLoading ? 'Active' : 'Syncing' }}</span>
          </div>
          <div>
            <div @click="minimize = !minimize"><i class="fa-solid fa-down-left-and-up-right-to-center"></i></div>
          </div>
        </div>
        <div v-if="!isLoading && !isPaused" class="px-6 py-2" style="display: flex; justify-content: space-between; border-top: 1px solid #ebe6e7; border-bottom: 1px solid #ebe6e7; background-color: #ffffff4d">
          <div style="display: flex; align-items: center; gap: 0.5rem;"><i class="fa-light fa-clock"></i><span>Next Check:</span></div>
          <span>{{ display }}</span>
        </div>

        <div class="px-6 pt-3">
          <div style="display: flex; justify-content: space-between;">
            <div style="display: flex; align-items: center; gap: 0.5rem;"><i class="fa-regular fa-circle-check"></i><span>Matches Today:</span></div>
            <span>{{ stats.NbReconciliation }}</span>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <div style="display: flex; align-items: center; gap: 0.5rem;"><i class="fa-regular fa-arrow-trend-up"></i><span>Volume today:</span></div>
            <span>€{{ stats.AmountReconciliation.toFixed(2) }}</span>
          </div>
          <hr>
        </div>

        <div class="px-6 pb-3" style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.5rem;">
          <button style="border: 1px solid #0000001a; color: black; background-color: #fff;" class="btn btn-primary" @click="isPaused = !isPaused"><i :class="['fa-regular', {'fa-pause': !isPaused, 'fa-play': isPaused}]"></i> {{ isPaused ? 'Start' : 'Pause' }}</button>
          <button class="btn btn-dark" @click="runReconciliation"><i class="fa-regular fa-bolt"></i>{{ isLoading ? 'Running...' : 'Run now' }}</button>
        </div>
      </div>

      <div v-else @click="minimize = !minimize" style="display: flex; align-items: center; gap: 0.5rem;" :class="['card-min p-6', {yellow: isPaused && !isLoading, blue: isLoading && !isPaused, green: !isPaused && !isLoading}]">
        <span>🤖</span>
        <div :style="{'border-radius': '50%', 'background-color': isPaused? '#f0b100': !isLoading ? '#00c951':'oklch(62.3% 0.214 259.815)', height: '0.6rem', width: '0.6rem'}"></div>
        <span v-if="!isLoading && !isPaused">{{ display }}</span>
      </div>
      <f7-pages :class="['content bg-light' + (!connected  ? 'marginHomepageLargeScreen': ''), { expanded: isSidebarOpen }]"></f7-pages>
    </f7-view>
  </f7-views>

  <cm-popups></cm-popups>
  <notifications-rtp style="top:80px;z-index:10070;"/>

</div>
</template>

<script>
import LeftPanel from './components/leftpanel/LeftPanel.vue'
import HeaderPanel from './components/menus/HeaderPanel.vue'
import MobileHeader from '@/components/menus/MobileHeader.vue'
import notificationsRTP from '@/components/common/notificationsLink.vue'

import design from '@/design/design.json'

import networkMixin from './mixins/networkMixin'

import CMPopup from '@/popups/Popups.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage, reloadPage} from '@/helpers/routing'

/* eslint-disable no-tabs */
/* eslint-disable indent */
export default {
  name: 'MoneyRoad',
  mixins: [networkMixin], //  dynamicStyleMixin],
  components: {
    // 'cm-devis': FormDevis,
    // 'cm-reglament': FormReglament,
    // 'enroll-message': enrollMessage,
    // 'bottom-toolbar': bottomToolbar,
    'cm-popups': CMPopup,
    'left-panel': LeftPanel,
    'header-panel': HeaderPanel,
    'mobile-header': MobileHeader,
    'notifications-rtp': notificationsRTP,
    // 'right-panel': RightPanel,
    // 'web-header': HeaderPanel
  },
  data: () => {
    return {
      apiVersion: '',
      context: 'RTP',
      design: design,
      service: '',
      connected: false,
      webheaderKey: false,
      defaultService: 'Direct Debit',
      surveyConnectedMins: 0,
      surveyConnectedSecs: 10,
      url: '',
      isPaused: false,
      isLoading: false,
      time: 10,
      timeLeft: 10,
      timer: null,
      display: '00:00',
      isSidebarOpen: true,
      minimize: false,
      stats: {}
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  created () {
    let that = this
    this.$engine.services.payments.getStats()
    .then(resp => {
      this.stats = resp.data
    })
    /* setInterval(this.watchApiVersion, 1000)
    this.watchApiVersion() */
    this.$engine.auth.login({
      Login: 'admin',
      Password: '8d969eef6ecad3c29a3a629280e686cf0c3f5d5a86aff3ca12020c923adc6c92',
      ConnectBy: 'lpc',
      WithPassword: '1'
    })
    .then(resp => {
      /* that.$engine.user.connectBy = 'login-password-capi' */
      /*this.$bus.emit('login', true)
      this.$bus.emit('service:change', this.defaultService)
      this.$bus.emit('refresh-cache-menu')
      this.$f7.hidePreloader()
      this.$$('.panel-overlay').css('z-index', '')
      this.$$('.deleteNavBar').removeClass('deleteNavBar')*/
      that.connected = true
      that.url = 'dashboard'
    })
    .catch(err => {
      console.log('ERROR',err)
      that.$f7.hidePreloader()
    })
    var data = this.getJsonFromUrl(window.location.href)
    if (data.loginSSO === '1' && data.login && data.OTP) {
      this.$engine.auth.loginOTP({ email: data.login, otp: data.OTP })
        .then(resp => {
          that.details = {}
          if (resp.status === 200) {
            setTimeout(function () { /* Timeout for letting time to load vue components */
              that.$engine.user.setIsFirstLogin('0')
              window.location = window.location.href.split('?')[0]
            }, 0)
          } else {
          }
        })
        .catch(err => {
          throw new Error(err)
        })
    } else {
      /* if (data.OTP && data.email && data.ressource) {
        this.url = '/OTP/' + data.email + '/' + data.OTP + '/' + data.ressource
      } else if (this.$engine.applicationMode === 'standard') {
        this.url = '/login/'
      } else {
        this.url = ''
      } */
      let that = this
      this.$bus.$on('reset-webheader', () => {
        that.webheaderKey = !that.webheaderKey
      })
      /*this.$engine.getApiVersion()
      .then(resp => {
        if (resp.data.version) {
          that.apiVersion = resp.data.version
          that.$engine.versionAPI = resp.data.version
        }
      })
      .catch(err => {
        errorMessageAlert(err, that, true)
      })*/
    }
  },
  mounted () {
    this.startCountdown()
    let that = this
    this.$bus.$on('login', function (login) {
      if (login) {
        if (login !== 'iframe') {
          that.connected = true
        }
      }
      if (that.$engine.user.getIsFirstLogin() === '1' || that.$engine.user.get().isFirstLogin === '1') {
        that.$bus.$emit('popup-change-password-data')
      }
    })
    this.$bus.$on('logout', function (force) {
      this.$bus.$emit('close-all-popups')
      this.$engine.auth.logout(force).then(response => {
        that.connected = false
        this.$engine.user.currentService.name = ''
        reloadPage(that, {
          url: '/login/',
          force: true,
          ignoreCache: true
        })
      })
    })

    for (let key in this.cssVars) {
      document.documentElement.style.setProperty(key, this.cssVars[key])
    }
    /* setInterval(this.checkAppVersion(), 30000)
    this.checkAppVersion()
    this.surveyConnected() */
  },
  computed: {
    cssVars () {
      return {
        // BOUTONS
        '--actionButtonSimpleGris': this.design.global.actionSimpleGris,
        '--actionButtonColorBlue': this.design.global.actionButtonColorBlue,
        '--borderButtonColorBlue': this.design.global.borderButtonColorBlue,
        '--actionButtonColorViolet': this.design.global.actionButtonColorViolet,
        '--borderButtonColorViolet': this.design.global.borderButtonColorViolet,
        '--borderRadius': this.design.global.borderRadius,
        // TEXTE
        '--actionTextColorWhite': this.design.global.actionTextColorWhite,
        '--actionTextColorBlack': this.design.global.actionTextColorBlack,
        '--actionTextColorWhiteHover': this.design.global.actionTextColorWhiteHover,
        '--spacing': this.design.global.spacing,
        '--text-lg': this.design.global.textlg,
        '--text-lg--line-height': this.design.global.textlgLineHeight,
        // POLICE
        '--fontFamily': this.design.global.fontFamily,
        '--fontSize': this.design.global.fontSize,
        // Couleur des tableaux et onglets actifs
        "--actionButtonSimpleGrisBleu": this.design.global.actionButtonSimpleGrisBleu
      }
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    surveyConnectedTimer () {
      return ((this.surveyConnectedMins * 60) + this.surveyConnectedSecs) * 1000
    },
    titleNavBar () {
      let style = {
        'background-color': this.servicesColors.DEFAULT
      }
      if (!this.online) style['background-color'] = '#f44336'
      return style
    }
  },
  notifications: {
    showNetworkOffline: {
      type: 'error',
      title: '',
      message: 'Your device is offline'
    },
    showNetworkOnline: {
      type: 'info',
      title: '',
      message: 'Connection is now available'
    }
  },
  watch: {
    online (isOnline) {
      if (isOnline) {
        this.showNetworkOnline()
      } else {
        this.showNetworkOffline()
      }
    }
  },
  methods: {
    startCountdown() {
      this.timer = setInterval(() => {
        
        if (this.isPaused) return
        
        if (this.timeLeft > 1) {
          this.timeLeft--
          const minutes = Math.floor(this.timeLeft / 60);
          const seconds = this.timeLeft % 60;
  
          this.display = `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
        } else {
          this.runReconciliation()
          clearInterval(this.timer)

          this.isPaused = false
          this.isLoading = true

          setTimeout(() => {
            this.timeLeft = this.time
            const minutes = Math.floor(this.time / 60);
            const seconds = this.time % 60;
    
            this.display = `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
            this.isLoading = false
            this.isPaused = false
            this.startCountdown()
          }, 500)
        }
      }, 1000)
    },
    runReconciliation (){
      this.$engine.services.payments.getStats()
      .then(resp => {
        this.stats = resp.data
      })
    },
    checkAppVersion () {
      let that = this
      fetch('config.xml')
      .then(res => res.text())
      .then(str => {
        const parser = new DOMParser()
        const version = parser.parseFromString(str, "application/xml")?.querySelector('widget')?.getAttribute('version')
        let localVersion = that.$engine.getIHMVersion()
        if (version) {
          if (localVersion) {
            if (version !== localVersion) {
              that.$engine.setIHMVersion(version)
              location.reload(true);
            }
          } else {
            that.$engine.setIHMVersion(version)
          }
        }
      })
    },
    getJsonFromUrl (url) {
      if (!url) url = location.href
      var question = url.indexOf('?')
      var hash = url.indexOf('#')
      if (hash === -1 && question === -1) return {}
      if (hash === -1) hash = url.length
      var query = (question === -1 || hash === question + 1) ? url.substring(hash) : url.substring(question + 1, hash)
      var result = {}
      query.split('&').forEach(function (part) {
        if (!part) return
        part = part.split('+').join(' ') // replace every + with space, regexp-free version
        var eq = part.indexOf('=')
        var key = eq > -1 ? part.substr(0, eq) : part
        var val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : ''
        var from = key.indexOf('[')
        if (from === -1) result[decodeURIComponent(key)] = val
        else {
          var to = key.indexOf(']', from)
          var index = decodeURIComponent(key.substring(from + 1, to))
          key = decodeURIComponent(key.substring(0, from))
          if (!result[key]) result[key] = []
          if (!index) result[key].push(val)
          else result[key][index] = val
        }
      })
      return result
    },
    surveyConnected () {
      let that = this
      setTimeout(function () {
        if (that.connected && that.$engine.common.network.isSessionExpired()) {
          that.$engine.user.manageSession()
          .then(resp => {
          })
          .catch(err => {
            errorMessageAlert(err, that, true)
          })
          .finally(() => {
            that.surveyConnected()
          })
        } else {
          that.surveyConnected()
        }
      }, that.surveyConnectedTimer)
    },
    watchApiVersion () {
      let newApiVersion = this.$engine.common.network.getAPIVersion()
      if (!this.apiVersion) {
        this.apiVersion = newApiVersion
      } else if (this.apiVersion !== newApiVersion) {
        window.location.reload(true)
      }
    }
  }
}
</script>

<style scoped media="screen">

.content {
  transition: margin-left 0.25s ease, width 0.25s ease;
  margin-left: 3%;
  width: 97%;
}

.content.expanded {
  margin-left: 18%;
  width: 82%;
}

.card-auto {
  position: absolute; 
  right: 1rem; 
  bottom: 7.5rem; 
  height: fit-content; 
  z-index: 1; 
  width: 25rem; 
  border-radius: calc(0.625rem + 4px); 
}

.card-min {
  position: absolute; 
  right: 1rem; 
  bottom: 7.5rem; 
  height: 4rem; 
  z-index: 1; 
  width: fit-content; 
  border-radius: calc(0.625rem + 4px); 
}

.yellow {
  background-color: #fefce8;
  border: 2px solid #fef08a;
}

.blue {
  background-color: #eff6ff;
  border: 2px solid #bedbff;
}

.green {
  background-color: #f0fdf4;
  border: 2px solid #b9f8cf;
}

.hiddenBlock {
  display: none;
}

@media (min-width: 850px) {
  .marginHomepageLargeScreen {
    top: 0px; max-height: calc(100% - 80px);
  }
}

</style>
